import axios from 'axios';
import lazyImages from "./lazyImages/lazyImages";
import Modal from "bootstrap.native/dist/components/modal-native.esm";

const heroCarousel = document.querySelector('.il-large-carousel');
const tearCarousel = document.querySelector('.tears-carousel');

function largeCarouselImages(event) {
    const swiper = heroCarousel.swiper;

    swiper.on('slideChange', function (swiper) {
        if (swiper.activeIndex === 3) {
            axios
                .get('/api/home/media/large-carousel')
                .then(response => {
                    console.log(swiper);
                    response.data.forEach((slide, key) => {
                        if (key > 4)
                            swiper.appendSlide(` <div class="swiper-slide il-slide d-block" itemscope="" itemprop="itemListElement" itemtype="http://schema.org/ListItem"> <a class="il-link" href="${slide.link}"> <div class="il-image-container w-100 h-100"><picture> <source type="image/webp" data-srcset="${slide.media.webp}" sizes="100vw"> <source type="image/jpeg" data-srcset="${slide.media.jpeg}" sizes="100vw"> <img class="object-fit w-100 h-100 carousel-lazy-img il-lazy-image il-ajax-added" width="2250" height="1500" src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2250 1500'%3E%3C/svg%3E" alt="${slide.title}" data-src="${slide.media.src}" ></picture></div> <span class="il-slideinfo text-center w-auto"> <p class="il-title h2">${slide.title}</p> <p class="il-subtitle h5 mt-1"> ${slide.subtitle}</p> </span> </a> <meta content="${slide.title}" itemprop="name"> <meta content="${key}" itemprop="position"> </div> `);
                    });
                    let images = document.querySelectorAll("img.il-ajax-added");
                    lazyImages(images);
                }).catch(err => console.error(err))
        }
    });

}

heroCarousel.addEventListener('carouselInitilized', largeCarouselImages);

const tearCarouselImages = event => {
    let swiper = tearCarousel.swiper;

    swiper.on('slideChange', function (swiper) {
        if (swiper.activeIndex === 1) {
            axios
                .get('/api/home/media/tear-carousel')
                .then(response => {

                    response.data.forEach((slide, key) => {
                        if (key > 5) {
                            if (!!!slide.media.location) {
                                console.log(slide.media);
                            };

                            if (!!slide.media.location && slide.media.tear) {
                                swiper.appendSlide(`<div class="swiper-slide il-slide" itemscope="" itemprop="itemListElement" itemtype="http://schema.org/ListItem"> <div class="d-flex"> <div class="il-img-bg-container--tear position-relative"> <div class="il-image-container il-img-bg--tear il-md-h"> <div class="spinner-grow text-secondary position-absolute" role="status"> Testing <span class="sr-only">Loading...</span> </div> <picture> <source type="image/webp" data-srcset="${slide.media.tear.webp}" sizes="100vw"> <source type="image/jpeg" data-srcset="${slide.media.tear.jpeg}" sizes="100vw"> <img class="w-100 h-100 object-fit carousel-lazy-img il-lazy-image" src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 777 1000'%3E%3C/svg%3E" alt="${slide.subtitle}" data-src="${slide.media.tear.src}" > </picture></div> </div> <div class="il-img-bg-container pl-2 position-relative w-100"> <div class="il-image-container il-md-h w-100 il-md-h"> <div class="spinner-grow text-secondary position-absolute" role="status"> <span class="sr-only">Loading...</span> </div> <picture> <source type="image/webp" data-srcset="${slide.media.location.webp}" sizes="100vw"> <source type="image/jpeg" data-srcset="${slide.media.location.jpeg}" sizes="100vw"> <img class="w-100 h-100 object-fit carousel-lazy-img il-lazy-image" width="1050" height="700" src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1050 700'%3E%3C/svg%3E" alt="${slide.subtitle}" data-src="${slide.media.location.src}" > </picture></div> </div> </div> <div class="il-slideinfo text-center w-auto d-flex justify-content-center p-md-3 p-2"> <a class="text-reset text-decoration-none text-truncate" href="${slide.link}"> ${slide.title} <span>&nbsp;|&nbsp;</span> ${slide.subtitle} </a> </div> <meta content="${slide.title}" itemprop="name"> <meta content="5" itemprop="position"> </div>`);
                            }
                        }
                    });
                    let images = tearCarousel.querySelectorAll("img.il-lazy-image");
                    lazyImages(images);
                }).catch(err => console.error(err))
        }
    });
}

tearCarousel.addEventListener('carouselInitilized', tearCarouselImages);


// Modal
// let modalTrigger = document.querySelector("#holiday-modal-trigger");
// window.holidayModal = new Modal(modalTrigger);
// window.holidayModal.show();
// setTimeout(() => {
//     window.holidayModal.hide();
// }, 5000);


